function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// import _ from 'lodash/fp'
// import GraniteError from 'granite-admin/utils/granite-error'

// TODO: try to merge it with mapToSnakeCase
// NOTE: this method map backend employee keys to frontend naming convention
const mapToCamelCase = ({
  pk,
  employee_id,
  name,
  is_active,
  username,
  first_name,
  last_name,
  title,
  phone_no,
  email,
  role,
  modified_date_display,
  address,
  designation,
  status,
  ...rest
}) => {
  return {
    pk,
    name,
    username,
    email,
    title,
    designation,
    employeeId: employee_id,
    phoneNumber: phone_no,
    isActive: is_active,
    firstName: first_name,
    lastName: last_name,
    role: role,
    lastActivity: modified_date_display,
    address,
    status,
    ...rest
  };
};
class Employee {
  constructor({
    mapValues,
    ..._data
  }) {
    _defineProperty(this, "mapToSnakeCase", () => {
      const data = {
        name: [this.firstName, this.lastName].filter(Boolean).join(' '),
        designation: this.designation,
        employee_id: this.employeeId,
        role: this.role,
        is_active: this.isActive,
        status: this.status,
        address: this.address?.pk ? {
          pk: this.address?.pk
        } : {},
        user: {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone: this.phoneNumber
        }
      };
      if (!data.status) delete data['status'];
      return data;
    });
    if (mapValues) _data = mapToCamelCase(_data);

    // if (_.isNil(data.username) || !_.isString(data.username)) {
    //   throw new GraniteError('User must have username')
    // }

    // this.username = data.username

    this.firstName = _data.firstName || '';
    this.lastName = _data.lastName || '';
    this.email = _data.email || '';
    this.pk = _data.pk;
    this.designation = _data.designation || '';
    this.role = _data.role || [];
    this.phoneNumber = _data?.phone || _data.phoneNumber || '';
    this.isActive = _data.isActive ?? true;
    this.lastActivity = _data.lastActivity;
    this.address = _data.address || {};
    this.name = _data.name ?? _data.user.first_name + ' ' + _data.user.last_name;
    this.employeeId = _data.employeeId || '';
    this.address = _data.address;
    this.status = _data.status;
    this.modified_at = _data.modified_at;
    this.user_pk = _data.user?.pk;
    this.profileImage = _data.user?.profile_image;
    this.isOwner = _data.is_owner;
    this.extraData = _data.extra_data;
  }
}
export default Employee;